import { TournamentId } from '@store/modules/ui/sportOffer/marketFilters/types';
import { VirtualTournament } from '@sportOfferFederation/competitions/types';
import OfferEvent from '@core/models/offer/OfferEvent';

export function getEventByTournamentFilter(tournamentId: TournamentId | null, virtualTournament: VirtualTournament | null): (result: OfferEvent) => boolean {
    if (!tournamentId && !virtualTournament) {
        return () => false;
    }

    if (virtualTournament) {
        return (event) => virtualTournament.childrenIds.includes(event.tournamentId);
    } else {
        return (event) => event.tournamentId === tournamentId;
    }
}
